/* eslint-disable */ 
import logo from './logo.svg';
import './App.css';
import Loader from './Loader';

function App() {
	return (
		<div>
			<Loader />
		</div>
	);
}

export default App;
